import {Question} from '@agenium-ai/agenium-client-sdk/dist/models';
import {stripHtml} from 'string-strip-html';
import InputText from './core/InputText';

export interface AgTextInputProps {
    question: Question;
    onChange?: (s: string) => void;
    value: string;
    type?: 'text' | 'numeric';
    classes?: Record<string, string>;
}

const MultilineInput = (props: AgTextInputProps) => {
    const {question, value, onChange, type = 'text', classes} = props;

    function handleChange(e: any) {
        const v: string = e.target.value;
        onChange?.(v);
    }

    return (
        <div>
            <InputText
                name={question.key}
                type={type}
                onChange={handleChange}
                multiline
                value={value}
                label={stripHtml(question.questionText).result}
                parentClass="form-group"
                {...(classes && {classes: classes})}
            />
        </div>
    );
};

export default MultilineInput;
